import React from 'react';
import { Tooltip } from 'antd';
import { useParams } from 'react-router-dom';
import Flyout from './Flyout';
import styles from './ShapesFlyout.module.css';
import { useCanvas } from '../../../context/canvasContext';
import { useDocument } from '../../../context/documentInfoContex';
import { boardServices } from '../../../api';
import { CircleIcon } from '../../SvgShapes/circle';
import { RectangleIcon } from '../../SvgShapes/rectangle';
import { TriangleIcon } from '../../SvgShapes/triangle';
import { EllipseIcon } from '../../SvgShapes/ellipse';
import { PentagonIcon } from '../../SvgShapes/pentagon';
import { HexagonIcon } from '../../SvgShapes/hexagon';
import { HeptagonIcon } from '../../SvgShapes/heptagon';
import { OctagonIcon } from '../../SvgShapes/octagon';
import { StarIcon } from '../../SvgShapes/star';
import { DiamondIcon } from '../../SvgShapes/diamond';
import { TrapezoidIcon } from '../../SvgShapes/trapezoid';
import { ParallelogramIcon } from '../../SvgShapes/parallelogram';
import { HeartIcon } from '../../SvgShapes/heart';
import { CrossIcon } from '../../SvgShapes/cross';
import { ChevronIcon } from '../../SvgShapes/chevron';
import { SemicircleIcon } from '../../SvgShapes/semiCircle';
import { PentagramIcon } from '../../SvgShapes/pentagram';
import { CrescentIcon } from '../../SvgShapes/crescent';

const SHAPES = [
    ['circle', 'Circle', CircleIcon], ['rectangle', 'Rectangle', RectangleIcon], ['triangle', 'Triangle', TriangleIcon],
    ['ellipse', 'Ellipse', EllipseIcon], ['pentagon', 'Pentagon', PentagonIcon], ['hexagon', 'Hexagon', HexagonIcon],
    ['heptagon', 'Heptagon', HeptagonIcon], ['octagon', 'Octagon', OctagonIcon], ['star', 'Star', StarIcon],
    ['diamond', 'Diamond', DiamondIcon], ['trapezoid', 'Trapezoid', TrapezoidIcon], ['parallelogram', 'Parallelogram', ParallelogramIcon],
    ['heart', 'Heart', HeartIcon], ['cross', 'Cross', CrossIcon], ['chevron', 'Chevron', ChevronIcon],
    ['semicircle', 'Semicircle', SemicircleIcon], ['pentagram', 'Pentagram', PentagramIcon], ['crescent', 'Crescent', CrescentIcon],
];

/** Grid of shapes; picking one adds it to the canvas and saves the board. */
const ShapesFlyout = ({ onClose }) => {
    const { id } = useParams();
    const canvas = useCanvas();
    const { setSavingData, isTemplateDocument } = useDocument();

    const creators = {
        circle: canvas.createCircle, rectangle: canvas.createRectangle, triangle: canvas.createTriangle,
        ellipse: canvas.createEllipse, pentagon: canvas.createPentagon, hexagon: canvas.createHexagon,
        heptagon: canvas.createHeptagon, octagon: canvas.createOctagon, star: canvas.createStar,
        diamond: canvas.createDiamond, trapezoid: canvas.createTrapezoid, parallelogram: canvas.createParallelogram,
        heart: canvas.createHeart, cross: canvas.createCross, chevron: canvas.createChevron,
        semicircle: canvas.createSemicircle, pentagram: canvas.createPentagram, crescent: canvas.createCrescent,
    };

    const addShape = async (shapeId) => {
        creators[shapeId](id);
        if (!canvas.canvasRef?.current) return;
        try {
            const data = canvas.canvasRef.current.toJSON(['selectable', 'id', 'type']);
            await boardServices.updateBoardData(id, data, setSavingData, isTemplateDocument);
        } catch (error) {
            console.error('Failed to update board after adding shape:', error);
        }
    };

    return (
        <Flyout title="Shapes" onClose={onClose}>
            <div className={styles.grid}>
                {SHAPES.map(([shapeId, name, ShapeIcon]) => (
                    <Tooltip key={shapeId} title={name}>
                        <button type="button" className={styles.cell} onClick={() => addShape(shapeId)} aria-label={name}>
                            <ShapeIcon />
                        </button>
                    </Tooltip>
                ))}
            </div>
        </Flyout>
    );
};

export default ShapesFlyout;
